import { ActiveFarmTypography } from '../../components/CustomStyles/StyledComponents';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { ReportStatus } from '../../helpers/reportResultsHelper'
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';

export default function SelectedReport({ reportName }) {
  const rptStatus = useSelector(state => state?.farmReport?.reportDetails?.status);
  const rptFID = useSelector(state => state?.farmReport?.reportDetails?.friendlyReportId);
  const NoName = "[Not Named]"
  return (
    <Stack direction="row"  sx={{ justifyContent: "space-between"}}>
      <ActiveFarmTypography style={{ marginBottom: '5px' }}>
        <span style={{ fontWeight: 'bold' }} >Report : </span>
        {rptFID ? `${rptFID} - ` : ''}
        {reportName || NoName}
      </ActiveFarmTypography>
      { ((typeof rptStatus !== 'undefined') && (rptStatus !== null))
        && <Chip color="success"   sx={{ m: 0.2 }}
        size="small" variant="outlined" label={`${ReportStatus.getStatusText(rptStatus)}`} />}
    </Stack>
  );
}

SelectedReport.propTypes = {
  reportName: PropTypes.string
};